module.exports = __webpack_public_path__ + "static/media/n-erlanger.bd252498.png";